import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
//
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataModule } from '@data/data.module';
import { MontageOrdersModule } from './montage-orders/montage-orders.module';
import { CustomersModule } from './customers/customers.module';
import { PartnersModule } from './partners/partners.module';
import { TeamsModule } from './teams/teams.module';

import { ToolbarModule } from './toolbar/toolbar.module';

import { StateService } from '@services/state.service';
import { GlobalEventServiceService } from '@services/global-event-service.service';
import { NavigationService } from '@services/navigation.service';
import { APP_BASE_HREF } from '@angular/common';
import { UserDeviceService } from '@services/user-device.service';
import { MatDialogModule } from '@angular/material/dialog';
import { EmptyComponent } from './empty/empty.component';
import { ImageEditModule } from './image-edit/image-edit.module';
import { HammerModule } from '@angular/platform-browser';
import { DocumentEditorModule } from './document-editor/document-editor.module';
import { MatListModule } from '@angular/material/list';
import { TrashModule } from './trash/trash.module';
import { TestGuiModule } from './test-gui/test-gui.module';

@NgModule({
  declarations: [
    AppComponent,
    EmptyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    /**/
    CustomersModule,
    DataModule,
    DocumentEditorModule,
    ImageEditModule,
    MontageOrdersModule,
    TrashModule,
    PartnersModule,
    TeamsModule,
    ToolbarModule,
    HammerModule,
    TestGuiModule
  ],
  providers: [
    GlobalEventServiceService,
    NavigationService,
    StateService,
    {
      provide: APP_BASE_HREF,
      useValue: '/' + (window.location.pathname.split('/')[1] || '')
    },
    UserDeviceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
